module.exports = __webpack_public_path__ + "static/media/pedido-entregado-cilindro-gray.67f7c160.svg";